import { APP_CONFIG, clearAllCache, ROUTES, oAuthService } from '@sd/shared';

export const logout = async () => {
  clearAllCache();
  // slo callback is called here because it is not properly called on the ping logout
  // page for localhost development
  if (APP_CONFIG.build.environment === 'dev') await oAuthService.sloCallback();
  location.assign(
    ROUTES.external.oauth.logout.externalUrlFor({
      TargetResource: ROUTES.appShell.root.externalUrlFor(),
      InErrorResource: ROUTES.appShell.root.externalUrlFor()
    })
  );
};
